import {isMobile as mobile} from "react-device-detect";
import {isBrowser as browser} from "react-device-detect";

export const isMobile = process.env.REACT_APP_IS_MOBILE && process.env.REACT_APP_IS_MOBILE === 'true' ? true : mobile;
export const isBrowser = process.env.REACT_APP_IS_MOBILE && process.env.REACT_APP_IS_MOBILE === 'true' ? false : browser;
